// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__hgy-S","inner":"Footer_inner__166qn","nextIcon":"Footer_nextIcon__2V-rK","innerLeft":"Footer_innerLeft__1a5Al"};